import React, { useContext, useState } from 'react';
import { ActionModal } from '../../../../components/Modal';
import { TextInput } from '../../../../components/TextInput';
import { Button, ButtonVariant } from '../../../../components/Button';
import { useToast } from '../../../../../providers/ToastProvider';
import { ToastType } from '../../../../components/Toast';
import { useMutation } from '@apollo/client';
import { Unilever } from '../../../../../types/customer/DHL/Unilever/Unilever';
import { OrderContext } from '../../../../../context/OrderContext';
import { Order } from '../../../../../types/order';

interface ProcessMessageModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function ProcessMessageModal({ open, setOpen }: ProcessMessageModalProps) {
  const { showToast } = useToast();

  const { orders, setOrders } = useContext(OrderContext);

  const [message, setMessage] = useState<string>('');

  const [importMessage, { loading }] = useMutation<Unilever.ProcessMessageResponse, Unilever.ProcessMessageVariables>(
    Unilever.processMessage,
    {
      onCompleted: res => {
        const created = res.processMessage;

        created.forEach(order => orders.set(order.id, new Order(order)));
        setOrders(new Map(orders));

        showToast({
          type: ToastType.success,
          title: `Imported ${created.length} orders successfully.`,
        });
        setOpen(false);
      },
      onError: err => {
        showToast({
          type: ToastType.error,
          title: err.message,
        });
      },
    },
  );

  const handleMessage = async () => {
    await importMessage({ variables: { message } });
  };

  const footer = (
    <div className='flex justify-end gap-2'>
      <Button disabled={loading} variant={ButtonVariant.secondary} text={'Cancel'} onClick={() => setOpen(false)} />
      <Button loading={loading} text={'Import'} onClick={handleMessage} />
    </div>
  );

  return (
    <ActionModal
      footer={footer}
      title={'Process Unilever Message'}
      open={open}
      setOpen={setOpen}
      className='max-w-[720px]'
    >
      <div>
        <TextInput mandatory value={message} onChange={v => setMessage(v)} label={'Message'} placeholder={'Message'} />
      </div>
    </ActionModal>
  );
}
